import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ContractsService } from 'app/services/contract/contracts.service';
import { UserService } from 'app/services/user/user.service';
import { first, switchMap, takeWhile, tap, timer } from 'rxjs';
import { TokenService } from 'app/services/contract/contracts-services/token.service';
import { BigNumber } from "ethers";
import { SpinnerService } from 'app/services/spinner/spinner.service';
import { LootboxesContractService } from 'app/services/contract/contracts-services/lootboxes.service';
import { UserItemsService } from 'app/services/user-items/user-items.service';
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { IUserLootboxItemsResponse } from 'app/services/user-items/user-items.interface';
import { eContracts } from 'app/services/contract/contract.config';
import { IIngameItem } from '../balances-item/balances-item-interface';

@Component({
  selector: 'quick-purchase',
  templateUrl: './quick-purchase.component.html',
  styleUrls: ['./quick-purchase.component.scss']
})
export class QuickPurchaseComponent implements OnChanges {
  @Input() data: IIngameItem;
  initQuantity: number;

  quantity: number = 1;

  constructor(
    private userService: UserService,
    private tokenService: TokenService,
    private lootboxesContractService: LootboxesContractService,
    private spinnerService: SpinnerService,
    private userItemsService: UserItemsService,
    private contractsService: ContractsService,
    private toastService: ToastService
  ) { }


  ngOnChanges(changes: SimpleChanges): void {
    if (this.data) this.initQuantity = this.data.balance;
  }

  changeQuantity(number: number) {
    this.quantity += number;
  }

  buy() {
    let that = this;
    let lootboxesContractAddress: string = this.contractsService.getContractAddress(eContracts.Lootbox);
    this.userService.userInfo$.subscribe(user => {
      this.tokenService.allowance(user.recordedWallet, lootboxesContractAddress).subscribe(allowance => {
        // console.log('allowance', allowance);
        let hasAllowanceItems = BigNumber.from(allowance).gt(0);
        // console.log('hasAllowanceItems', hasAllowanceItems);
        this.spinnerService.setSpinner(true);
        if (hasAllowanceItems) {
          // console.log('start Purchase');
          that.purchase(user.recordedWallet);
        } else {
          this.tokenService.approve(user.recordedWallet, lootboxesContractAddress).pipe(first()).subscribe({
            next(value) {
              console.log('value approve', value)
              that.purchase(user.recordedWallet);
            },
            error(err) {
              // console.log('err', err);
              //-32603 is a Magic code 
              if (err.code === -32603) that.toastService.add({
                severity: 'error',
                summary: 'errorMsg.insufficientFunds',
                detail: 'toastMessage.refillWallet',
              });
              else if (err.code === 4001) { }//Metamask code, user denied transaction
              else that.toastService.genericError();
              that.spinnerService.setSpinner(false);
            }
          }
          );
        }
      }
      )
    })
  }

  purchase(wallet: string) {
    let that = this;
    this.lootboxesContractService.buyItem(wallet, this.data.idOnchain, this.quantity)
      .pipe(first()).subscribe({
        next(item) {
          that.spinnerService.setSpinner(false);
          if (item.status) {
            console.log('purchase successful');
            // that.userItemsService.getLootboxItems(wallet).pipe(first()).subscribe();//to refresh item count
            that.refreshItemCount(wallet);
            that.tokenService.KMONbalance(wallet).pipe(first()).subscribe();//to refresh Kmon balance
            // that.spinnerService.setSpinner(false);
          } else {
            console.log('error purchase');
            that.spinnerService.setSpinner(false);
          }
        }, error(err) {
          if (err.code !== 4001) that.toastService.genericError();
          that.spinnerService.setSpinner(false);
        }
      })
  }

  refreshItemCount(wallet: string) {
    const maxAttempts = 20;
    const interval = 5000; // 6 seconds
    let attempts = 0;
    this.spinnerService.setSpinner(true);
    timer(0, interval)
      .pipe(
        takeWhile(() => attempts < maxAttempts),
        switchMap(() => this.userItemsService.getLootboxItems(wallet))
      ).subscribe((items: IUserLootboxItemsResponse[]) => {
        let newQuantity: number = items.filter(i => i.type == this.data.id)[0]?.count;
        newQuantity = newQuantity ? newQuantity : 0;
        if (newQuantity > this.initQuantity) attempts = maxAttempts
        else attempts++;
        console.log('number attepmpts:', attempts)
        if (attempts === maxAttempts) this.spinnerService.setSpinner(false);
      })
  }
}
